import { ColorMode } from '../../core/interfaces/color-mode';
import { useActiveTheme } from '../../theming/hooks/themeProvider';

export default function useEntityLogo(logo, darkModeLogo) {
  const colorMode = useActiveTheme();

  if (colorMode === ColorMode.DARK && darkModeLogo) {
    return darkModeLogo;
  }

  return logo;
}
